export default "__VITE_ASSET__f3c9fd30__"